var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "url(#paint0_linear_93_6167)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.3132 -5.74026e-08 12.6136 0.258658 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.7413 7.38642 20 8.68678 20 10H10L10 0Z",
    fill: "url(#paint1_linear_93_6167)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_6167",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_93_6167",
    x1: 10,
    y1: 20,
    x2: 10,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39531"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle1);
export default __webpack_public_path__ + "static/media/circle1.3222dfd72718a3ca27604ba10c33d81f.svg";
export { ForwardRef as ReactComponent };